module.exports = __webpack_public_path__ + "static/media/playstore@3x.8fc8b64c.png";